/**
 * 图片加载工具类
 * 用于统一管理项目中的图片资源路径
 */

console.log('imageLoader.js: 开始执行');

// OSS图片服务器基础URL
const OSS_BASE_URL = 'https://oss.joygem.net/official-website/assets/';
console.log('imageLoader.js: OSS_BASE_URL =', OSS_BASE_URL);

/**
 * 获取图片的完整OSS路径
 * @param {string} relativePath - 相对路径，例如：'LOGO.png', 'products/product_1.png'
 * @returns {string} 完整的OSS图片URL
 */
export function getImageUrl(relativePath) {
  try {
    // 检查relativePath是否存在
    if (!relativePath) {
      console.error('getImageUrl: relativePath is required');
      return '';
    }
    
    // 移除开头的@/assets/前缀（如果存在）
    let cleanPath = relativePath;
    if (cleanPath.startsWith('@/assets/')) {
      cleanPath = cleanPath.replace('@/assets/', '');
    }
    
    // 移除开头的/（如果存在）
    if (cleanPath.startsWith('/')) {
      cleanPath = cleanPath.slice(1);
    }
    
    // 拼接完整的OSS URL
    const url = `${OSS_BASE_URL || ''}${cleanPath}`;
    console.log('getImageUrl: generated URL =', url);
    return url;
  } catch (error) {
    console.error('getImageUrl: error occurred:', error);
    return '';
  }
}

/**
 * 获取图片的require路径（用于动态导入）
 * @param {string} relativePath - 相对路径，例如：'products/product_1.png'
 * @returns {string} require路径
 */
export function requireImage(relativePath) {
  try {
    // 保持原有的require路径结构
    return require(`@/assets/${relativePath}`);
  } catch (error) {
    console.error('requireImage: error occurred:', error);
    return '';
  }
}

/**
 * 图片资源常量定义
 */
let Images = {};

try {
  Images = {
    // 通用
    LOGO: getImageUrl('LOGO.png'),
    address: getImageUrl('address.png'),
    phone: getImageUrl('phone.png'),
    email: getImageUrl('email.png'),
    send: getImageUrl('send.png'),
    to_top: getImageUrl('to_top.png'),
    emblem: 'https://oss.joygem.net/official-website/assets/national_emblem.png',
    
    // 首页
    home: {
      left: getImageUrl('home/left.png'),
      right: getImageUrl('home/right.png'),
      meeting: getImageUrl('home/meeting.png'),
      business_1: getImageUrl('home/business_1.png'),
      business_2: getImageUrl('home/business_2.png'),
      business_3: getImageUrl('home/business_3.png'),
      business_4: getImageUrl('home/business_4.png'),
      to_right: getImageUrl('home/to_right.png'),
      product_1: getImageUrl('home/product_1.png'),
      product_2: getImageUrl('home/product_2.png'),
      product_3: getImageUrl('home/product_3.png'),
      ai_robot: getImageUrl('home/ai_robot.png'),
      background_1: getImageUrl('home/background_1.png'),
      background_2: getImageUrl('home/background_2.png'),
      background_3: getImageUrl('home/background_3.png'),
      background_4: getImageUrl('home/background_4.png')
    },
    
    // 产品页
    products: {
      background_1: getImageUrl('products/background_1.png'),
      background_2: getImageUrl('products/background_2.png'),
      app: getImageUrl('products/app.png'),
      icon_1: getImageUrl('products/icon_1.png'),
      icon_2: getImageUrl('products/icon_2.png'),
      icon_3: getImageUrl('products/icon_3.png'),
      to_right: getImageUrl('products/to_right.png'),
      product_1: getImageUrl('products/product_1.png'),
      product_2: getImageUrl('products/product_2.png'),
      product_3: getImageUrl('products/product_3.png'),
      product_4: getImageUrl('products/product_4.png'),
      product_5: getImageUrl('products/product_5.png'),
      product_6: getImageUrl('products/product_6.png'),
      AI_1: getImageUrl('products/AI_1.png'),
      AI_2: getImageUrl('products/AI_2.png'),
      AI_3: getImageUrl('products/AI_3.png'),
      AI_4: getImageUrl('products/AI_4.png'),
      left: getImageUrl('products/left.png'),
      right: getImageUrl('products/right.png')
    },
    
    // 下载页
    download: {
      background_1: getImageUrl('download/background_1.png'),
      ios: getImageUrl('download/ios.png'),
      ios_qr: getImageUrl('download/ios_qr.png'),
      android: getImageUrl('download/android.png'),
      android_qr: getImageUrl('download/android_qr.png'),
      icon_1: getImageUrl('download/icon_1.png'),
      icon_2: getImageUrl('download/icon_2.png'),
      icon_3: getImageUrl('download/icon_3.png'),
      icon_4: getImageUrl('download/icon_4.png'),
      app: getImageUrl('download/app.png'),
      scene_1: getImageUrl('download/scene_1.png'),
      scene_2: getImageUrl('download/scene_2.png'),
      scene_3: getImageUrl('download/scene_3.png'),
      scene_4: getImageUrl('download/scene_4.png'),
      Intelligent_dialogue: getImageUrl('download/Intelligent_dialogue.png'),
      translation: getImageUrl('download/translation.png'),
      audio_transcription: getImageUrl('download/audio_transcription.png'),
      icon_background: getImageUrl('download/icon_background.png')
    },
    
    // 登录页
    login: {
      background: getImageUrl('login/background.png'),
      wechat: getImageUrl('login/wechat.png'),
      qr_code: getImageUrl('login/qr_code.png')
    },
    
    // 新闻页
    news: {
      background: getImageUrl('news/background.png'),
      search: getImageUrl('news/search.png'),
      new_1: getImageUrl('news/new_1.png'),
      new_2: getImageUrl('news/new_2.png'),
      new_3: getImageUrl('news/new_3.png'),
      new_4: getImageUrl('news/new_4.png'),
      time: getImageUrl('news/time.png')
    },
    
    // 关于我们
    about: {
      background: getImageUrl('about/background.png'),
      to_left: getImageUrl('about/to_left.png'),
      to_right: getImageUrl('about/to_right.png'),
      advertisement_1: getImageUrl('about/advertisement_1.png'),
      advertisement_2: getImageUrl('about/advertisement_2.png'),
      advertisement_3: getImageUrl('about/advertisement_3.png'),
      partner_1: getImageUrl('about/partner_1.png'),
      partner_2: getImageUrl('about/partner_2.png'),
      partner_3: getImageUrl('about/partner_3.png'),
      partner_4: getImageUrl('about/partner_4.png'),
      partner_5: getImageUrl('about/partner_5.png'),
      partner_6: getImageUrl('about/partner_6.png'),
      partner_7: getImageUrl('about/partner_7.png'),
      partner_8: getImageUrl('about/partner_8.png'),
      dept_1: getImageUrl('about/dept_1.png'),
      dept_2: getImageUrl('about/dept_2.png'),
      dept_3: getImageUrl('about/dept_3.png'),
      dept_4: getImageUrl('about/dept_4.png'),
      dept_5: getImageUrl('about/dept_5.png')
    },
    
    // 充值页
    pay: {
      avatar: getImageUrl('pay/avatar.png'),
      crown: getImageUrl('pay/crown.png'),
      wechat: getImageUrl('pay/wechat.png'),
      alipay: getImageUrl('pay/alipay.png'),
      qr_code: getImageUrl('pay/qr_code.png'),
      background_2: getImageUrl('pay/background_2.png'),
      safety: getImageUrl('pay/safety.png'),
      alarmClock: getImageUrl('pay/alarm_clock.png')
    },
    
    // 联系我们
    contact: {
      background: getImageUrl('contact/background.png'),
      to_left: getImageUrl('contact/to_left.png'),
      to_right: getImageUrl('contact/to_right.png'),
      address: getImageUrl('contact/address.png')
    }
  };
  console.log('Images: successfully created');
} catch (error) {
  console.error('Images: error occurred:', error);
  Images = {
    // 通用
    LOGO: '',
    address: '',
    phone: '',
    email: '',
    send: '',
    to_top: '',
    emblem: '',
    
    // 首页
    home: {
      left: '',
      right: '',
      meeting: '',
      business_1: '',
      business_2: '',
      business_3: '',
      business_4: '',
      to_right: '',
      product_1: '',
      product_2: '',
      product_3: '',
      ai_robot: '',
      background_1: '',
      background_2: '',
      background_3: '',
      background_4: ''
    },
    
    // 产品页
    products: {
      background_1: '',
      background_2: '',
      app: '',
      icon_1: '',
      icon_2: '',
      icon_3: '',
      to_right: '',
      product_1: '',
      product_2: '',
      product_3: '',
      product_4: '',
      product_5: '',
      product_6: '',
      AI_1: '',
      AI_2: '',
      AI_3: '',
      AI_4: '',
      left: '',
      right: ''
    },
    
    // 下载页
    download: {
      background_1: '',
      ios: '',
      ios_qr: '',
      android: '',
      android_qr: '',
      icon_1: '',
      icon_2: '',
      icon_3: '',
      icon_4: '',
      app: '',
      scene_1: '',
      scene_2: '',
      scene_3: '',
      scene_4: '',
      Intelligent_dialogue: '',
      translation: '',
      audio_transcription: '',
      icon_background: ''
    },
    
    // 登录页
    login: {
      background: '',
      wechat: '',
      qr_code: ''
    },
    
    // 新闻页
    news: {
      background: '',
      search: '',
      new_1: '',
      new_2: '',
      new_3: '',
      new_4: '',
      time: ''
    },
    
    // 关于我们
    about: {
      background: '',
      to_left: '',
      to_right: '',
      advertisement_1: '',
      advertisement_2: '',
      advertisement_3: '',
      partner_1: '',
      partner_2: '',
      partner_3: '',
      partner_4: '',
      partner_5: '',
      partner_6: '',
      partner_7: '',
      partner_8: '',
      dept_1: '',
      dept_2: '',
      dept_3: '',
      dept_4: '',
      dept_5: ''
    },
    
    // 充值页
    pay: {
      avatar: '',
      crown: '',
      wechat: '',
      alipay: '',
      qr_code: '',
      background_2: ''
    },
    
    // 联系我们
    contact: {
      background: '',
      to_left: '',
      to_right: '',
      address: ''
    }
  };
}

export { Images };

export default { getImageUrl, requireImage, Images };
